import { ref } from 'vue'
import { ticketsExist } from '../api/tickets-exist'

export const hasSufficientTickets = ref(false)
export const isAwaitingFirstTickets = ref(false)

export const loadTicketsExist = async () => {
  const data = await ticketsExist()
  hasSufficientTickets.value = data.exists
}

const POLL_INTERVAL_MS = 30_000
const TIMEOUT_MS = 10 * 60 * 1000

export const startAwaitingFirstTickets = () => {
  if (isAwaitingFirstTickets.value) return

  isAwaitingFirstTickets.value = true

  let stopped = false
  const stop = () => {
    stopped = true
    isAwaitingFirstTickets.value = false
  }

  const poll = async () => {
    if (stopped) return
    try {
      await loadTicketsExist()
    } catch {
      // ignore transient errors, keep polling
    }
    if (hasSufficientTickets.value) {
      stop()
      return
    }
    setTimeout(poll, POLL_INTERVAL_MS)
  }

  setTimeout(poll, POLL_INTERVAL_MS)
  setTimeout(stop, TIMEOUT_MS)
}
